/* eslint-disable max-len */
import {
    BACKEND_EMAIL_ALREADY_REGISTERED_ERROR_CODE,
    BACKEND_INTERNET_CONN_ERROR_CODE,
    BACKEND_INVALID_ARGUMENTS_ERROR_CODE,
    BACKEND_INVALID_CREDENTIALS_ERROR_CODE,
    BACKEND_RECAPTCHA_ERROR_CODE,
    BACKEND_UNKNOWN_ERROR_CODE,
} from 'features/authentication/utils/constants';

export const ERROR_MESSAGES = {
    [BACKEND_INVALID_ARGUMENTS_ERROR_CODE]:
        'Invalid arguments. Please contact support@placer.ai for assistance',
    [BACKEND_INVALID_CREDENTIALS_ERROR_CODE]: 'This email is not allowed. Please use another email',
    [BACKEND_EMAIL_ALREADY_REGISTERED_ERROR_CODE]:
        'This email is already registered. Please login or recover your password.',
    [BACKEND_RECAPTCHA_ERROR_CODE]:
        'reCAPTCHA protection failed. Please refresh the page and try again. Contact support@placer.ai if issue repeats.',
    [BACKEND_UNKNOWN_ERROR_CODE]: 'Something went wrong... Please try again later.',
    [BACKEND_INTERNET_CONN_ERROR_CODE]: 'Please check your internet connection.',
};
